<template>
  <div class="body">
    <div class="MAIN" :style="{
      backgroundImage: 'url(' + srcImgUrl + ')',
      backgroundRepeat: 'no-repeat',
      'background-size': '100% 100%',
    }">
      <headerVisualization class="body"></headerVisualization>
      <div class="contain">
        <div class="leftContain">
          <div class="mobusbox" style="display:none;">
            <div :class="modbusitem.value !== '缺少' ? 'testmobus' : 'testmobus2'" v-for="modbusitem in modbusMap"
              :key="modbusitem.name">
              <div>{{ modbusitem.label }}</div>
              <div>{{ modbusitem.value }}</div>
              <div>{{ modbusitem.name }}</div>
            </div>
          </div>
          <!-- 展示数据 -->
          <processFlowDiagram @swichWater="swichWater"></processFlowDiagram>
          <div class="positionWarp" v-show="showPumpList">
            <div class="positon-mix">
              <div class="mixTitle">配比泵</div>
              <div class="mixRightBox">
                <div class="mixRightItem" v-for="item in mixDataList" :key="item.index">
                  <div class="mixRightItem-Left">
                    <img :src="require('@/assets/myImg/1/icon-map-' + item.index + '.png')"
                      style="height: 18px; width: 18px" />
                    <span class="itemTitle">{{ item.title }}</span>
                  </div>
                  <span class="itemVal">{{ item.val }}</span>
                </div>
              </div>
            </div>
            <div class="positon-mix">
              <div class="mixTitle">投加泵</div>
              <div class="mixRightBox">
                <div class="mixRightItem" v-for="item in mixDataList2" :key="item.index">
                  <div class="mixRightItem-Left">
                    <img :src="require('@/assets/myImg/1/icon-map-' + item.index + '.png')"
                      style="height: 18px; width: 18px" />
                    <span class="itemTitle">{{ item.title }}</span>
                  </div>
                  <span class="itemVal">{{ item.val }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rightContain">
          <WaterWorksSupply></WaterWorksSupply>
          <MonthlyIndicators></MonthlyIndicators>
          <MonitoringColumn></MonitoringColumn>
          <FaultAlarm></FaultAlarm>
        </div>
      </div>
      <!-- BannerTitle -->
      <div class="bannerTitle">
        <div class="bannerTip"></div>
        <span>{{ banerTitle }}</span>
      </div>
      <div class="positionItem" v-for="(item, index) in dataList" :key="index" :style="{
        top: item.top,
        left: item.left,
        width: item.width || '',
        height: item.height || '',
        color: item.color || '#00F6FF',
      }" v-html="item.val ? item.content + item.val : item.content"></div>
    </div>
  </div>
</template>

<script>
import headerVisualization from './modules/headerVisualization'
import processFlowDiagram from './modules/processFlowDiagram'
import WaterWorksSupply from './modules/WaterWorksSupply'
import MonthlyIndicators from './modules/MonthlyIndicators'
import MonitoringColumn from './modules/MonitoringColumn'
import FaultAlarm from './modules/FaultAlarm'
import MODBUS from './modbus.json'
import M from 'minimatch'

export default {
  name: 'WaterVisualization',
  components: {
    headerVisualization,
    processFlowDiagram,
    WaterWorksSupply,
    MonthlyIndicators,
    MonitoringColumn,
    FaultAlarm
  },
  data () {
    return {
      showPumpList: false,
      mixDataList: [
        {
          title: '1#清水泵',
          index: 1,
          val: '42.58L/H'
        },
        {
          title: '1#盐水泵',
          index: 2,
          val: '20.4L/H'
        },
        {
          title: '2#清水泵',
          index: 3,
          val: '0L/H'
        },
        {
          title: '2#盐水泵',
          index: 4,
          val: '0L/H'
        }
      ],
      mixDataList2: [
        {
          key: 'field_108',
          title: '1#沉淀池',
          index: 5,
          val: '44.44L/H',
          unit: 'L/H'
        },
        {
          key: 'field_109',
          title: '2#沉淀池',
          index: 6,
          val: '42.58L/H',
          unit: 'L/H'
        },
        {
          key: 'field_110',
          title: '2#清水池',
          index: 7,
          val: '42.58L/H',
          unit: 'L/H'
        },
        {
          key: 'field_111',
          title: '2#清水池',
          index: 8,
          val: '42.58L/H',
          unit: 'L/H'
        },
        {
          key: 'field_112',
          title: '投加泵备用',
          index: 9,
          val: '42.58L/H',
          unit: 'L/H'
        }
      ],
      banerTitle: '工艺流程',
      srcImgUrl: '/process.gif',
      dataList: [],
      dataList1: [
        {
          content: '1号处理池',
          top: '22.1%',
          left: '5.9%'
        },
        {
          content: '2号过滤地',
          top: '25.8%',
          left: '5.9%'
        },
        {
          content: '2号处理池',
          top: '29.4%',
          left: '5.9%'
        },
        {
          content: '排水渠',
          top: '33.1%',
          left: '5.9%'
        },
        {
          key: 'field_84',
          content: '叠合池(</br>反应沉淀池+</br>清水池) </br> 液位数值:',
          val: '2600m³',
          width: '110px',
          height: '85px',
          top: '36.6%',
          left: '5.9%',
          unit: 'm'
        },
        {
          content: '排水渠',
          top: '45.6%',
          left: '5.9%'
        },
        {
          content: '加压出水管',
          top: '57.5%',
          left: '7.7%'
        },
        {
          content: '加压进水管',
          top: '61%',
          left: '7.7%'
        },
        {
          content: '老2号过滤池',
          top: '21.4%',
          left: '28%'
        },
        {
          content: '1号过滤池',
          top: '25.1%',
          left: '28%'
        },
        {
          key: 'field_82',
          content: '2号清水池</br>液位数值:',
          val: '765m³',
          top: '15%',
          left: '56.4%',
          unit: 'm'
        },
        {
          key: 'field_81',
          content: '1号清水池</br>液位数值:',
          val: '742m³',
          top: '20.3%',
          left: '56.4%',
          unit: 'm'
        },
        {
          key: 'field_83',
          content: '3号清水池</br>液位数值:',
          val: '1582m³',
          top: '25.7%',
          left: '56.4%',
          unit: 'm'
        }
      ],
      dataList2: [
        {
          content: '堆矾区',
          top: '41.1%',
          left: '6.7%'
        },
        {
          key: 'field_15',
          content: '溶解池</br>溶液数值:',
          val: '3.2m',
          top: '23.2%',
          left: '17.3%',
          unit: 'm'
        },
        {
          content: '升降机',
          top: '28.7%',
          left: '17.3%'
        },
        {
          key: 'field_18',
          content: '投加量:',
          top: '62.3%',
          left: '19.5%',
          val: '20L/H',
          unit: 'L/H'
        },
        {
          content: '1#泵:',
          top: '62.3%',
          left: '25.1%',
          //val: '20HZ',
          val: '0HZ',
          unit: 'HZ'
        },
        {
          key: 'field_19',
          content: '2#泵:',
          top: '62.3%',
          left: '30.1%',
          val: '20HZ',
          unit: 'HZ'
        },
        {
          key: 'field_16',
          content: '1#溶液池</br>液位数值:',
          val: '3.2m',
          top: '41.5%',
          left: '60.1%',
          unit: 'm'
        },
        {
          key: 'field_17',
          content: '2#溶液池</br>液位数值:',
          val: '3.2m',
          top: '46.9%',
          left: '60.1%',
          unit: 'm'
        }
      ],
      dataList3: [
        {
          content: '溶盐池</br>液位数值:',
          val: '52.5cm',
          top: '23.3%',
          left: '4.8%',
          unit: 'cm'
        },
        {
          key: 'field_113',
          content: '饱和盐水池</br>液位数值:',
          val: '52.5cm',
          top: '28.7%',
          left: '4.8%',
          unit: 'cm'
        },
        // {
        //   key: 'field_114',
        //   content: '清水池</br>液位数值:',
        //   val: '52.5',
        //   top: '34%',
        //   left: '4.8%',
        //   unit: 'cm'
        // },
        {
          content: '堆盐区',
          top: '49.4%',
          left: '6.7%'
        },
        {
          key: 'field_103',
          content: '2#电极柜</br>温度:',
          val: '',
          top: '13.9%',
          left: '25.3%',
          unit: '℃'
        },
        {
          content: '2#整流柜',
          top: '19.2%',
          left: '25.3%'
        },
        // {
        //   key: 'field_101',
        //   content: '电压:',
        //   top: '20.8%',
        //   left: '25.3%',
        //   val: '',
        //   unit: 'Kv'
        // },
        {
          key: 'field_100',
          content: '电流:',
          top: '22.1%',
          left: '25.3%',
          val: '',
          unit: 'A'
        },
        {
          content: '控制柜',
          // val: '20A',
          val: '',
          top: '25%',
          left: '25.3%'
        },
        {
          content: '总配电柜',
          top: '28.7%',
          left: '25.3%'
        },
        {
          content: '1#控制柜',
          top: '23.4%',
          left: '58.6%'
        },
        {
          content: '1#整流柜',
          top: '26.5%',
          left: '58.6%'
        },
        // {
        //   key: 'field_99',
        //   content: '电压:',
        //   top: '28%',
        //   left: '58.6%',
        //   val: '30',
        //   unit: 'Kv'
        // },
        {
          key: 'field_102',
          content: '电流:',
          top: '29.3%',
          left: '58.6%',
          val: '20',
          unit: 'A'
        },
        {
          key: 'field_104',
          content: '1#电极柜</br>温度:',
          val: '37',
          top: '32.4%',
          left: '58.6%',
          unit: '℃'
        },
        {
          key: 'field_105',
          content: '1#存储罐</br>液位数值:',
          val: '123.5cm',
          top: '45.6%',
          left: '59.1%',
          unit: 'cm'
        },
        {
          key: 'field_106',
          content: '2#存储罐</br>液位数值:',
          val: '123.5',
          top: '51%',
          left: '59.1%',
          unit: 'cm'
        }
      ],
      dataList4: [
        {
          content: '总配电柜',
          top: '36%',
          left: '22.4%'
        },
        {
          content: '控制柜',
          top: '39.1%',
          left: '22.4%'
        },
        {
          content: '3号泵',
          top: '48.7%',
          left: '32%'
        },
        {
          content: '2号泵',
          top: '48.7%',
          left: '38.8%'
        },
        {
          content: '1号泵',
          top: '48.7%',
          left: '44.7%'
        },
        {
          content: '停止',
          top: '57.1%',
          left: '31.8%',
          color: '#FF4444'
        },
        {
          key: 'field_11',
          content: '电流:',
          top: '59.2%',
          left: '31.5%',
          color: '#FFFFFF',
          val: '110.5',
          unit: 'A'
        },
        {
          key: 'field_10',
          content: '电压:',
          top: '60.8%',
          left: '31.5%',
          color: '#FFFFFF',
          val: '52.62',
          unit: 'Hz'
        },
        {
          content: '停止',
          top: '57.1%',
          left: '37.9%',
          color: '#FF4444'
        },
        {
          key: 'field_7',
          content: '电流:',
          top: '59.2%',
          left: '37.5%',
          color: '#FFFFFF',
          val: '110.5',
          unit: 'A'
        },
        {
          key: 'field_6',
          content: '电压:',
          top: '60.8%',
          left: '37.5%',
          color: '#FFFFFF',
          val: '52.62',
          unit: 'Hz'
        },
        {
          content: '停止',
          top: '57.2%',
          left: '45.2%',
          color: '#FF4444'
        },
        {
          key: 'field_3',
          content: '电流:',
          top: '59.2%',
          left: '44.8%',
          color: '#FFFFFF',
          val: '110.5',
          unit: 'A'
        },
        {
          key: 'field_2',
          content: '电压:',
          top: '60.8%',
          left: '44.8%',
          color: '#FFFFFF',
          val: '52.62',
          unit: 'Hz'
        }
      ],
      dataList5: [
        {
          content: '网格反应区',
          top: '44.5%',
          left: '9.8%'
        },
        {
          content: '平流式沉淀区',
          top: '31.9%',
          left: '56.3%'
        },
        {
          content: '关',
          top: '28.7%',
          left: '18.8%'
        },
        {
          content: '关',
          top: '28.7%',
          left: '22.9%'
        },
        {
          content: '关',
          top: '28.7%',
          left: '28.1%'
        },
        {
          content: '关',
          top: '28.7%',
          left: '33.2%'
        },
        {
          content: '关',
          top: '28.7%',
          left: '38.7%'
        },
        {
          content: '关',
          top: '28.7%',
          left: '43.9%'
        },
        {
          content: '关',
          top: '66%',
          left: '14.1%'
        },
        {
          content: '关',
          top: '66%',
          left: '39.6%'
        },
        {
          content: '关',
          top: '66%',
          left: '47.1%'
        }
      ],
      modbusMap: [],
      modbusObj: {},
      timer: null
    }
  },
  created () {
    this.getList()
  },
  methods: {
    setTimer () {
      this.timer = null
      this.getWatermeter()
    },
    getList () {
      this.getWatermeter()
      this.dataList = this.dataList1
      this.srcImgUrl = '/process.gif'
    },
    // 获取水表数据
    getWatermeter () {
      const url = '/pipe-network/pipes/getDeviceInfo'
      this.modbusMap = []
      this.modbusObj = {}
      const that = this
      this.$http.get(url).then(({ data }) => {
        if (data) { // 根据返回状态判断
          that.timer = setTimeout(() => {
            that.setTimer()
          }, 5000)// 5秒查一下
        } else {
          clearTimeout(timer)// 清理定时任务
        }
        // =====加压泵站=====
        // // 1号泵 电流
        // data['field_11'] = 0
        // // 1号泵 电压
        // data['field_10'] = 0
        // // 2号泵 电流
        // data['field_7'] = 0
        // // 2号泵 电压
        // data['field_6'] = 0
        // // 3号泵 电流
        // data['field_3'] = 0
        // // 3号泵 电压
        // data['field_2'] = 0

        // // =====次氯酸钠制备间=====
        // // 饱和盐水池</br>液位数值
        // data['field_113'] = 52.4
        // // 清水池</br>液位数值
        // data['field_114'] = 52.5
        // // 电极柜</br>温度
        // data['field_104'] = 42
        // // 电压
        // data['field_100'] = 380
        // // 电流
        // data['field_101'] = 20
        // // 2#控制柜 -电压
        // data['field_102'] = 380
        // // 2#控制柜 -电流
        // data['field_103'] = 0
        // // 1#电极柜</br>温度
        // data['field_105'] = 0
        // // 1#存储罐</br>液位数值
        // data['field_106'] = 156
        // // 2#存储罐</br>液位数值
        // data['field_107'] = 178
        // // 1#沉淀池
        // data['field_108'] = 39.7
        // // 2#沉淀池
        // data['field_109'] = 13.5
        // // 2#清水池
        // data['field_110'] = 18
        // // 2#清水池
        // data['field_111'] = 21.5
        // // 投加泵备用
        // data['field_112'] = 0

        // // =====工艺流程=====
        // // 叠合池(</br>反应沉淀池+</br>清水池) </br> 液位数值
        data['field_84'] = 3.12
        // // 2号清水池</br>液位数值
        data['field_82'] = 2.85
        // // 1号清水池</br>液位数值
        data['field_81'] = 3.13
        // // 3号清水池</br>液位数值
        data['field_83'] = 3.42

        // // =====加矾系统=====
        // // 溶解池溶液数值
        // data['field_15'] = 1.24
        // // 投加量
        // data['field_18'] = 140
        // // 2#泵
        // data['field_19'] = 0
        // // 1#溶液池</br>液位数值
        // data['field_16'] = 1.26
        // // 2#溶液池</br>液位数值
        // data['field_17'] = 0.86

        const obj = {
          field_70: 1,
          field_71: data['field_71'],
          field_75: data['field_75'],
          field_76: data['field_76'],
          field_77: data['field_77'],
          field_78: data['field_78'],
          field_79: data['field_79'],
          field_80: data['field_80']
        }
        this.$store.commit('SET_SHUIZHI', true)
        Object.keys(MODBUS[0]).forEach((key) => {
          this.modbusObj[key] = data[key]
          console.log('data[key]===', data[key])
          const mmm = {
            name: key,
            value: data[key] || '缺少',
            label: MODBUS[0][key]
          }
          // console.log('mmm===', key, mmm)
          this.modbusMap.push(mmm)
          // 次氯酸钠悬浮
          // that.setFormatData(this.mixDataList2, data)
          // // 工艺流程
          that.setFormatData(this.dataList1, data)
          // 加矾系统
          that.setFormatData(this.dataList2, data)
          // 次氯酸钠
          that.setFormatData(this.dataList3, data)
          // 加压站
          that.setFormatData(this.dataList4, data)
        })
      })
    },
    // 格式化数据对接
    setFormatData (arr, data) {
      arr.forEach(element => {
        if (element.key) {
          element.val = data[element.key] === '0.00' ? '0' : data[element.key]
          if (element.unit) {
            element.val = element.val + element.unit
          }
        }
      })
    },
    swichWater (item) {
      this.showPumpList = false
      console.log(item.srcImgUrl)
      this.srcImgUrl = item.srcImgUrl || ''
      this.banerTitle = item.title
      this.$nextTick(() => {

        switch (item.index) {
          case 1:
            this.dataList = this.dataList1
            break
          case 2:
            this.dataList = this.dataList2
            break
          case 3:
            this.dataList = this.dataList3
            this.showPumpList = true
            break
          case 4:
            this.dataList = this.dataList4
            break
          case 5:
            for (let i = 0; i < 18; i++) {
              this.dataList5.push({
                content: '关',
                top: '66%',
                left: 14.1 + 1.32 * i + '%'
              })
            }

            this.dataList = this.dataList5
            break
          default:
            this.dataList = []
        }

      })
    }
  },
  mounted () {

  }
}
</script>

<style lang="less" scoped>
.body {
  width: 100%;
}

.MAIN {
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  background-color: rgb(0, 25, 46);
  position: relative;

  .contain {
    z-index: 1;
    // height: calc(100vh - 58px);
    padding: 14px;
    // padding-bottom: 26px;
    padding-left: 24px;
    padding-top: 42px;
    height: 100%;
    height: 1022px;
    // height: 1300px;
    width: 100vw;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .leftContain {
      width: 1308px;
      height: 100%;
      // height: 982px;
      display: flex;
      flex-direction: column-reverse;
    }

    .rightContain {
      width: 540px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // border: red solid 1px;
    }

    // position: relative;
  }

  .bannerTitle {
    height: 46px;
    position: absolute;
    top: 129px;
    left: 63px;
    display: flex;
    align-items: center;

    .bannerTip {
      height: 28px;
      width: 6px;
      background: #10c0ff;
    }

    span {
      margin-left: 12px;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 34px;
      color: #10c0ff;
      font-weight: 600;
    }
  }

  .positionItem {
    display: inline-block;
    position: absolute;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #00f6ff;
    font-weight: 400;
  }

  .mobusbox {
    width: 1300px;
    display: flex;
    height: 340px;
    flex-flow: row wrap;
    color: #fff;
  }

  .testmobus {
    width: 128px;
    height: 60px;
    margin: 1px;
    border: 1px solid #ae8760;
  }

  .testmobus2 {
    width: 128px;
    height: 60px;
    margin: 1px;
    border: 1px solid #ae8760;
    background: red;
  }

  .positionWarp {
    display: flex;
    flex-direction: row;
    width: 1000px;

    .positon-mix {
      // position: absolute;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 40px;
      margin-left: 93px;
      width: 100%;

      .mixTitle {
        width: 20px;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 20px;
        color: #00f6ff;
        font-weight: 600;
      }

      .mixRightBox {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 100px;

        .mixRightItem {
          margin-top: 8px;
          margin-left: 8px;
          background: rgba(8, 54, 100, 0.8);
          height: 42px;
          width: 202px;
          display: flex;
          align-items: center;
          padding: 12px 14px;
          justify-content: space-between;

          .itemVal {
            font-family: MicrosoftYaHeiSemibold;
            font-size: 16px;
            color: #10c0ff;
            text-align: right;
            font-weight: 600;
          }

          .mixRightItem-Left {
            display: flex;
            align-items: center;

            .itemTitle {
              font-family: MicrosoftYaHeiSemibold;
              font-size: 14px;
              color: #099bfb;
              font-weight: 600;
              margin-left: 8px;
            }
          }
        }
      }
    }
  }
}
</style>
